import { Exception } from './exception';

export class NotImplementedException extends Exception {}
